// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_ASSET, EDIT_ASSET, ASSET, GET_ASSET, DELETE_ASSET } from '../../../../common/constant'

export const actionAsset = createAsyncThunk('appAsset/actionAsset', async (params, thunkAPI) => {
    return await post(ASSET, params, thunkAPI)
})

export const actionAddAsset = createAsyncThunk('appAsset/actionAddAsset', async (params, thunkAPI) => {
    return await put(ADD_ASSET, params, thunkAPI)
})

export const actionGetAsset = createAsyncThunk('appAsset/actionGetAsset', async (params, thunkAPI) => {
    return await post(GET_ASSET, params, thunkAPI)
})

export const actionEditAsset = createAsyncThunk('appAsset/actionEditAsset', async (params, thunkAPI) => {
    return await post(EDIT_ASSET, params, thunkAPI)
})

export const actionDeleteAsset = createAsyncThunk('appAsset/actionDeleteAsset', async (params, thunkAPI) => {
    return await post(DELETE_ASSET, params, thunkAPI)
})

export const appAssetSlice = createSlice({
    name: 'appAsset',
    initialState: {
        //list
        loading: false,
        asset: null,

        //add
        loadingAdd: false,
        addAsset: null,

        //get
        loadingGet: false,
        getAsset: null,

        //edit
        loadingEdit: false,
        editAsset: null,

        //delete
        loadingDelete: false,
        deleteAsset: null

    },
    reducers: {
        //reset or delete Add Asset store data
        resetAssetResponse: (state) => {
            state.asset = null
        },
        resetAddAssetResponse: (state) => {
            state.addAsset = null
        },
        resetGetAssetResponse: (state) => {
            state.getAsset = null
        },
        resetEditAssetResponse: (state) => {
            state.editAsset = null
        },
        resetDeleteAssetResponse: (state) => {
            state.deleteAsset = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionAsset.pending, (state) => {
                state.loading = true
            })
            .addCase(actionAsset.fulfilled, (state, action) => {
                state.loading = false
                state.asset = action.payload
            })
            .addCase(actionAsset.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddAsset.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddAsset.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addAsset = action.payload
            })
            .addCase(actionAddAsset.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetAsset.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetAsset.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getAsset = action.payload
            })
            .addCase(actionGetAsset.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditAsset.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditAsset.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editAsset = action.payload
            })
            .addCase(actionEditAsset.rejected, (state) => {
                state.loadingEdit = false
            })

             //delete
             .addCase(actionDeleteAsset.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteAsset.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteAsset = action.payload
            })
            .addCase(actionDeleteAsset.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetAssetResponse, resetAddAssetResponse, resetGetAssetResponse, resetEditAssetResponse, resetDeleteAssetResponse } = appAssetSlice.actions

export default appAssetSlice.reducer